import React, { useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'

/**
 * Okno modalne zlecenia (okno adresu i kontaktu, D16). Portal do `body` w `.vv-dom` (tokeny kolorów), bo karta listy
 * ma `container-type`, a to robi z niej blok zawierający dla `position: fixed`.
 *
 * Klawiatura: fokus wchodzi na pole z `autoFocus` albo na pierwszy element, Tab krąży w oknie, Escape zamyka,
 * po zamknięciu fokus wraca tam, skąd okno otwarto.
 */
const FOKUSOWALNE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'

const OknoZlecenia = ({ etykieta, onZamknij, children, className = 'dialog' }) => {
  const okno = useRef(null)
  const zamknijRef = useRef(onZamknij)
  zamknijRef.current = onZamknij

  useEffect(() => {
    const poprzedni = document.activeElement
    const el = okno.current
    const start = el?.querySelector('[data-autofokus]') || el?.querySelector(FOKUSOWALNE)
    start?.focus()
    const klawisz = (e) => {
      if (e.key === 'Escape') { e.stopPropagation(); zamknijRef.current?.(); return }
      if (e.key !== 'Tab' || !el) return
      const lista = [...el.querySelectorAll(FOKUSOWALNE)].filter((x) => x.offsetParent !== null || x === document.activeElement)
      if (!lista.length) return
      const pierwszy = lista[0]
      const ostatni = lista[lista.length - 1]
      if (e.shiftKey && document.activeElement === pierwszy) { e.preventDefault(); ostatni.focus() }
      else if (!e.shiftKey && document.activeElement === ostatni) { e.preventDefault(); pierwszy.focus() }
    }
    document.addEventListener('keydown', klawisz, true)
    const przewijanie = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.removeEventListener('keydown', klawisz, true)
      document.body.style.overflow = przewijanie
      if (poprzedni && typeof poprzedni.focus === 'function') poprzedni.focus()
    }
  }, [])

  return createPortal(
    <div className="vv-dom">
      <div className="vv-okno-tlo" onMouseDown={(e) => { if (e.target === e.currentTarget) onZamknij?.() }}>
        <div ref={okno} role="dialog" aria-modal="true" aria-labelledby={etykieta} className={className}>
          {children}
        </div>
      </div>
    </div>,
    document.body,
  )
}

export default OknoZlecenia
